import staticQueryData from "../../../../public/static/d/901429211.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import { theme, ThemeProvider } from '@smooth-ui/core-sc';
import { Header } from 'smooth-code-landers';
var QUERY = "901429211";
export function WebsiteHeader() {
  return React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      return data.site.siteMetadata.standalone === false ? React.createElement(ThemeProvider, {
        theme: theme
      }, React.createElement(Header, {
        variant: "shadow"
      })) : null;
    },
    data: staticQueryData
  });
}